module.exports = __webpack_public_path__ + "static/media/hearts-queen.043d4a77.png";